import { render } from "./WoundPanelTestSelection.vue?vue&type=template&id=4256c541"
import script from "./WoundPanelTestSelection.vue?vue&type=script&lang=js"
export * from "./WoundPanelTestSelection.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/cases/testInfo/testSelection/WoundPanelTestSelection.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4256c541"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4256c541', __exports__)) {
    console.log('reload')
    api.reload('4256c541', __exports__)
  }
  
  module.hot.accept("./WoundPanelTestSelection.vue?vue&type=template&id=4256c541", () => {
    console.log('re-render')
    api.rerender('4256c541', render)
  })

}


export default __exports__